import { gql } from "@apollo/client";

const COMBINED_FEED_CLIP_FIELDS = gql`
  fragment CombinedFeedClipFields on Clip {
    id
    internalId
    shareId
    title
    thumbnailUrl(style: STANDARD)
    url(orientation: LANDSCAPE)
    createdAt
    type
    game
    isPinned
    user {
      _id
      username
      avatarUrl
    }
  }
`;

export const COMBINED_FEED_QUERY = gql`
  ${COMBINED_FEED_CLIP_FIELDS}

  query CombinedFeed($limit: Int, $excludeClipIds: [String!]) {
    me {
      followingClips(options: { excludeClipIds: $excludeClipIds, limit: 10 }) {
        ...CombinedFeedClipFields
      }
      playedWithClips(options: { excludeClipIds: $excludeClipIds, limit: 10 }) {
        ...CombinedFeedClipFields
      }
      proPlayerClips(options: { excludeClipIds: $excludeClipIds, limit: 20 }) {
        ...CombinedFeedClipFields
      }
    }
    recommendedClips: clipsRecommended(limit: $limit) {
      ...CombinedFeedClipFields
    }
  }
`;
